export default "__VITE_ASSET__CYhZpDT___"